import { DEFAULT_CURRENCY_CODE } from "./currencies.constants";
import { UNITS } from "./units.constant";

export const DEFAULT_CHEMICAL_CURRENCY_CODE = DEFAULT_CURRENCY_CODE;
export const DEFAULT_CHEMICAL_DENSITY_UNIT = UNITS.gcm3;

// TO-DO:recheck the names after getting the chemicals from the API
export const IMPORT_ALLOWED_CHEMICAL_CATEGORIES = [
  "acid",
  "alkali",
  "cip_additive",
  "antiscalant",
  "dechlorinator",
];

// TO-DO:recheck the exclded chemical with team
export const EXCLUDED_CHEMICAL_LIST = [
  {
    chemical_name: "Sulfuric Acid",
    symbol: "H₂SO₄",
  },
];
